(function () {
  var data = window.hkBuilder;
  if (!data) return;

  var TIER_PRODUCTS = {
    light: 'lite-challenge-pack-2',
    regular: 'regular-challenge-pack-2',
    gains: 'gains-challenge-pack-4'
  };

  var state = {
    meals: '10',
    tier: 'regular',
    type: 'Standard',
    extras: 'None',
    freq: 'subscribe',
    dateIndex: 0
  };

  /* ---------- NZ date helpers ---------- */
  function nzNow() {
    var s = new Date().toLocaleString('en-US', { timeZone: 'Pacific/Auckland' });
    return new Date(s);
  }
  function nextCutoff(from) {
    var d = new Date(from.getTime());
    var day = d.getDay();
    var diff = (1 - day + 7) % 7;
    var cut = new Date(d.getFullYear(), d.getMonth(), d.getDate() + diff, 18, 0, 0);
    if (cut <= from) cut = new Date(cut.getTime() + 7 * 864e5);
    return cut;
  }
  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  function fmtLong(d) { return 'Monday, ' + d.getDate() + ' ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear(); }
  function fmtProp(d) { return MONTHS[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear(); }
  function fmtShort(d) { return 'Monday, ' + d.getDate() + ' ' + MONTHS[d.getMonth()]; }

  var deliveryOptions = [];
  (function buildDates() {
    var cut = nextCutoff(nzNow());
    for (var i = 0; i < 4; i++) {
      var c = new Date(cut.getTime() + i * 7 * 864e5);
      deliveryOptions.push({ cutoff: c, delivery: new Date(c.getTime() + 7 * 864e5) });
    }
    var sel = document.getElementById('hkDate');
    deliveryOptions.forEach(function (o, i) {
      var opt = document.createElement('option');
      opt.value = i;
      opt.textContent = fmtLong(o.delivery);
      sel.appendChild(opt);
    });
    sel.addEventListener('change', function () { state.dateIndex = +sel.value; render(); });
  })();

  /* ---------- variant resolution ---------- */
  function mealsValue() {
    if (state.meals === '5L') return '5 (Lunch)';
    if (state.meals === '5D') return '5 (Dinner)';
    return state.meals;
  }
  function product(tier) { return data.products[TIER_PRODUCTS[tier || state.tier]]; }
  function findVariant(tier, meals, type) {
    var p = product(tier);
    if (!p) return null;
    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i];
      if (v.o1 === meals && v.o2 === type && v.o3 === (state.extras || 'None')) return v;
    }
    return null;
  }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function mealCount() { return state.meals === '5L' || state.meals === '5D' ? 5 : +state.meals; }

  /* ---------- render ---------- */
  function setActive(nodes, test) {
    nodes.forEach(function (n) { n.classList.toggle('is-active', test(n)); });
  }
  function $all(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }

  function render() {
    ['light', 'regular', 'gains'].forEach(function (t) {
      var v = findVariant(t, mealsValue(), state.type) || findVariant(t, mealsValue(), 'Standard');
      var el = document.querySelector('[data-tier-price="' + t + '"]');
      if (el) el.textContent = v ? money(v.price / mealCount()) + '/meal' : '—';
    });

    var veganBtn = document.querySelector('[data-type="Vegan"]');
    var veganOk = !!findVariant(state.tier, mealsValue(), 'Vegan');
    veganBtn.disabled = !veganOk;
    document.getElementById('hkVeganNote').hidden = veganOk;
    if (!veganOk && state.type === 'Vegan') state.type = 'Standard';

    setActive($all('[data-meals]'), function (n) { return n.dataset.meals === state.meals; });
    setActive($all('.hk-tierpick__row'), function (n) { return n.dataset.tier === state.tier; });
    setActive($all('[data-type]'), function (n) { return n.dataset.type === state.type; });
    setActive($all('[data-extras]'), function (n) { return n.dataset.extras === state.extras; });
    setActive($all('[data-freq]'), function (n) { return n.dataset.freq === state.freq; });
    setActive($all('.hk-thumb'), function (n) { return n.dataset.tier === state.tier; });

    var p = product();
    var subRow = document.getElementById('hkSubRow');
    subRow.style.display = p && p.sellingPlanId ? '' : 'none';
    if (!(p && p.sellingPlanId)) state.freq = 'onetime';

    var img = document.getElementById('hkMainImg');
    if (p && p.image) img.src = p.image;

    var v = findVariant(state.tier, mealsValue(), state.type);
    var addBtn = document.getElementById('hkAdd');
    if (v) {
      var per = v.price / mealCount();
      document.getElementById('hkLineDesc').textContent = mealCount() + ' meals × ' + money(per);
      document.getElementById('hkLinePrice').textContent = money(v.price);
      document.getElementById('hkTotal').textContent = money(v.price);
      document.getElementById('hkAddLabel').textContent = 'Add to order — ' + money(v.price);
      addBtn.disabled = false;
    } else {
      document.getElementById('hkLineDesc').textContent = 'Combination unavailable';
      document.getElementById('hkLinePrice').textContent = '—';
      document.getElementById('hkTotal').textContent = '—';
      document.getElementById('hkAddLabel').textContent = 'Unavailable';
      addBtn.disabled = true;
    }

    var o = deliveryOptions[state.dateIndex];
    document.getElementById('hkCutoffCopy').innerHTML =
      'Order before <strong>' + fmtShort(o.cutoff) + ' 6pm</strong> to get meals delivered <strong>' + fmtShort(o.delivery) + '</strong>.';
    document.getElementById('hkMenuWeek').textContent = 'Week of ' + fmtShort(o.delivery);
    tickCountdown();
  }

  function tickCountdown() {
    var o = deliveryOptions[state.dateIndex];
    var ms = o.cutoff - nzNow();
    var el = document.getElementById('hkCountdown');
    if (ms <= 0) { el.textContent = 'Cutoff passed for this date'; return; }
    var d = Math.floor(ms / 864e5), h = Math.floor(ms % 864e5 / 36e5), m = Math.floor(ms % 36e5 / 6e4);
    el.textContent = '⏰ Cutoff in ' + d + 'd ' + h + 'h ' + m + 'm';
  }
  setInterval(tickCountdown, 30000);

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-meals],[data-type],[data-extras],[data-freq],.hk-tierpick__row,.hk-thumb');
    if (!t) return;
    if (t.dataset.meals) { state.meals = t.dataset.meals; }
    else if (t.dataset.extras) { state.extras = t.dataset.extras; }
    else if (t.dataset.type && !t.disabled) { state.type = t.dataset.type; state.extras = 'None'; }
    else if (t.dataset.freq) { state.freq = t.dataset.freq; }
    else if (t.dataset.tier) { state.tier = t.dataset.tier; }
    render();
  });

  /* ---------- add to cart ---------- */
  document.getElementById('hkAdd').addEventListener('click', function () {
    var v = findVariant(state.tier, mealsValue(), state.type);
    if (!v) return;
    var o = deliveryOptions[state.dateIndex];
    var btn = this;
    btn.disabled = true;
    var payload = {
      items: [{
        id: v.id,
        quantity: 1,
        properties: { 'Delivery Date': fmtProp(o.delivery) }
      }]
    };
    var p = product();
    if (state.freq === 'subscribe' && p.sellingPlanId) payload.items[0].selling_plan = p.sellingPlanId;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); }); return r.json(); })
      .then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'Delivery Date': fmtProp(o.delivery) } })
        });
      })
      .then(function () { window.location.href = '/cart'; })
      .catch(function (err) {
        btn.disabled = false;
        var box = document.getElementById('hkError');
        box.textContent = err.message;
        box.hidden = false;
      });
  });

  render();
})();
